import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,

  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,

} from 'react-share';
import "./styles.css";
import { RaisedButton, Loader } from '../../components';
import { switchApplyPopup } from '../../actions';

class Footer extends Component {
  render(){
    let imgUrl = '/img/footer-img.jpg' //footer-img-locations.jpg
    if(this.props.pathname.indexOf('location') !== -1){
      imgUrl = '/img/footer-img-locations.jpg' //footer-img-locations.jpg
    }
    return (
      <footer>
        <div className="footer-main-image">
          <img src={imgUrl} alt="" />
          <div className="middle"><RaisedButton text="Join Now" onClick={() => {
            this.props.dispatch(switchApplyPopup(true));
          }}/></div>
        </div>
        <div className="social-share-buttons">
          <div className="social-share-headline">SHARE</div>
          <FacebookShareButton
            url={'http://adidas-hack.com/'}
            quote={'adidas Hackathon'}
            className="share-icon">
            <FacebookIcon
              logoFillColor="white"
              iconBgStyle={{
                fill: 'black'
              }}
            />
          </FacebookShareButton>
          <TwitterShareButton
            url={'http://adidas-hack.com/'}
            quote={'adidas Hackathon'}
            className="share-icon">
            <TwitterIcon
              logoFillColor="white"
              iconBgStyle={{
                fill: 'black'
              }}
            />
          </TwitterShareButton>
          <LinkedinShareButton
            url={'http://adidas-hack.com/'}
            quote={'adidas Hackathon'}
            className="share-icon">
            <LinkedinIcon
              logoFillColor="white"
              iconBgStyle={{
                fill: 'black'
              }}
            />
          </LinkedinShareButton>
        </div>
        <div className="footer-bottom">
          <div>
              <div className="footer-nav">
                <div className="footer-button"><a target="_blank" href="/terms_conditions-privacy_policy.pdf">Terms & Conditions | Privacy Policy</a></div>
                <div className="footer-button"><a href="mailto:hack.info@adidas.com">CONTACT US</a> </div>
              </div>
              <div className="footer-right">
                <div className="footer-auto-space">Here To C_____</div>
              </div>
          </div>
        </div>
        <Loader show={this.props.showLoader}/>
      </footer>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    events: state.challenges.data,
    showModal: state.apply.showPopup,
    showLoader: state.details.loading,
    pathname: state.routerReducer.location.pathname
  }
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js